<template>
  <div class="discuss-item cl">
    <div class="discuss-top">
      <img
        class="user-icon"
        :src="
          dataList.icon ? dataList.icon : '../../static/img/mr-usericon.png'
        "
        alt=""
        @click="userCenter(dataList.userId)"
      />
      <div class="discuss-itemlist">
        <div v-if="dataList.pid == 0" class="user-name">
          {{ dataList.userName }}
          <img v-if="dataList.userCertify == 1" class="dv-rz" src="/static/img/d-v-rz.png" alt=""> 
        </div>
        <div v-else class="user-name">
          {{ dataList.userName }}
          <img v-if="dataList.userCertify == 1" class="dv-rz" src="/static/img/d-v-rz.png" alt=""> 
          <span class="discuss-hf">回复</span>
          <img
            class="user-icon mr10"
            :src="
              dataList.picon
                ? dataList.picon
                : '../../static/img/mr-usericon.png'
            "
            alt=""
            @click="userCenter(dataList.userId)"
          />
          {{ dataList.puserName }}
          <img v-if="dataList.userCertify == 1" class="dv-rz" src="/static/img/d-v-rz.png" alt=""> 
        </div>
        <div class="discuss-content" v-html="dataList.content"></div>
        <div class="discuss-cz">
          <span class="mr20">{{ dataList.createTime }}</span>
          <span hidden class="report mr20">举报</span>
          <span hidden class="dz mr20">点赞</span>
          <span class="hf mr20" @click="hfBtn">回复</span>
        </div>
      </div>
    </div>
    <div v-if="hidden" class="textarea-box">
      <!-- <div class="pic-icon">
        <el-popover placement="top-start" trigger="click" popper-class="emoBox" >
          <div class="emotionList">
            <a href="javascript:void(0);" class="emotionItem"
              v-for="(item, i) in faceList" :key="i"
              @click="getEmo(i,index)" >{{ item }}</a>
          </div>
          <el-button class="emotionSelect" slot="reference">
            <img src="../assets/images/icon/set-icon.png" alt="" />
          </el-button>
        </el-popover>
      </div> -->
      <div v-if="userToken" class="textarea">
        <!-- <el-input
          type="textarea"
          placeholder="发布你的看法"
          v-model="textarea"
          maxlength="200"
          :id="'optionText'+ index"
          resize="none"
        >
        </el-input> -->
        <vue-ueditor-wrap
          v-model="textarea"
          :config="myConfig"
        ></vue-ueditor-wrap>
      </div>
      <el-button v-if="userToken" class="discuss-btn" @click="discussBtn(dataList.id)"
        >评论</el-button
      >
      <div v-else class="no-login">
                  请先<span @click="loginTo">登录</span>后发表评论
                </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import emoji from "emoji.json";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  name: "hotPost",
  components:{
    VueUeditorWrap
  },
  props: ["dataList",'index'],
  data() {
    return {
      userToken: store.state.UserToken
        ? store.state.UserToken
        : localStorage.getItem("UserToken"),
      userInfo: store.state.UserInfo
        ? store.state.UserInfo
        : JSON.parse(localStorage.getItem("UserInfo")),
      textarea: "",
      hidden: false,
      faceList:[],
      myConfig: {
        UEDITOR_HOME_URL: "/static/ue/",
        initialFrameHeight:200,
        autoFloatEnabled:false,
        zIndex:0,
        toolbars: [ [
          // 'emotion',
          'insertimage',
          'forecolor',
          'autotypeset',
        ]]
      },
    };
  },
  mounted() {
    for(let i in emoji){
      this.faceList.push(emoji[i].char);
    }
  },
  methods: {
    //插入表情
    getEmo(index,num){
      var textArea = document.getElementById('optionText'+num);
        function changeSelectedText(obj, str) {
          str = str + " ";
          if (window.getSelection) {
            // 非IE浏览器
            textArea.setRangeText(str);
            // 在未选中文本的情况下，重新设置光标位置
            textArea.selectionStart += str.length;
            textArea.focus()
          } else if (document.selection) {
            // IE浏览器
            obj.focus();
            var sel = document.selection.createRange();
            sel.text = str;
          }
        }
        changeSelectedText(textArea,this.faceList[index]);
        this.textarea = textArea.value;
        return;
    },
    hfBtn() {
      this.hidden = !this.hidden;
    },
    discussBtn(id) {
      if(!this.textarea) {
        this.$message.error('请输入评论');
        return false
      }
      this.$api
        .discussAdd({
          content: this.textarea,
          pid: id,
          targetType: this.dataList.targetType,
          targetId: this.dataList.targetId,
        })
        .then((res) => {
          this.$message.success(res.data.msg);
          this.textarea = '';
        });
    },
    loginTo() {
      this.$router.push("/login?url=" + window.location.pathname);
    },
    userCenter(id) {
      let routeData = this.$router.resolve("/usercenter/" + id)
      window.open(routeData.href, '_blank')
    },
  },
};
</script>
<style lang="scss" scoped>
.discuss-item {
  width: 100%;
  //   display: flex;
  //   flex-direction:column;
  border-bottom: 1px solid #efefef;
  padding: 20px 0;
  .discuss-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .user-icon {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      cursor: pointer;
    }
    .discuss-itemlist {
      width: 581px;
      .user-name {
        width: 100%;
        font-size: 16px;
        font-weight: 600;
        color: #121212;
        line-height: 22px;
        display: flex;
        align-items: center;
        .discuss-hf {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          margin: 0 10px;
        }
        .dv-rz {
            width: 16px;
            height: 16px;
            margin-left: 5px;
          }
      }
      .discuss-content {
        width: 100%;
        margin-top: 10px;
        font-size: 15px;
        font-weight: 400;
        color: #121212;
        line-height: 24px;
        /deep/ img {
          max-width: 100%;
        }
      }
      .discuss-cz {
        width: 100%;
        display: flex;
        margin-top: 10px;
        span {
          font-size: 13px;
          font-weight: 400;
          color: #666666;
          line-height: 18px;
        }
        .report {
          cursor: pointer;
          background: url("../assets/images/report-icon.png") no-repeat left
            center;
          padding-left: 15px;
        }
        .dz {
          cursor: pointer;
          background: url("../assets/images/icon/zan-icon.png") no-repeat left
            center;
          padding-left: 15px;
        }
        .hf {
          cursor: pointer;
        }
      }
    }
  }

  .textarea-box {
    width: 581px;
    float: right;
    margin-top: 10px;
    .pic-icon {
      width: 100%;
      height: 28px;
      line-height: 28px;
      border-bottom: 1px solid #efefef;
      img {
        width: 12px;
        height: 12px;
        cursor: pointer;
      }
      button{
        padding: 6px 10px;
        background: none;
        border: none;
      }
    }
    .no-login {
              width: 100%;
              height: 94px;
              line-height: 94px;
              text-align: center;
              color: #121212;
              font-size: 15px;
              background: #f7f7f7;
              border-radius: 4px;
              border: 1px solid #eeeeee;
              span {
                cursor: pointer;
                color: #317DFF;
              }
            }
    .textarea {
      width: 100%;
      /deep/ .el-textarea__inner {
        border: none !important;
        background: #f7f7f7 !important;
      }
    }
    .discuss-btn {
      width: 64px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      color: #ffffff;
      background: #317DFF;
      border-radius: 4px;
      float: right;
      font-size: 15px;
      // margin-right: 10px;
      padding: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DiscussList.vue